<template>
  <VContainer v-if="showPromo" fluid class="pa-0">
    <VCarousel
      hide-delimiters
      cycle
      interval="7000"
      :show-arrows="false"
      height="auto"
    >
      <VCarouselItem v-for="(message, index) in promoMessages" :key="index" transition="fade-transition" :ripple="false">
        <VRow no-gutters justify="center" class="text-secondary">
          <VCol class="pa-2 align">
            <!-- eslint-disable-next-line vue/no-v-html -->
            <span class="ribbon-text" v-html="message" />
          </VCol>
        </VRow>
      </VCarouselItem>
    </VCarousel>
    <VDivider />
  </VContainer>
</template>

<script setup lang="ts">
import { useCartStore } from '~/stores/cart'

const $i18n = useI18n()

const cartStore = useCartStore()

const showPromo = computed(() => (promoMessages.value?.length ?? 0) > 0)

const promoMessages = computed(() =>
  cartStore.summary.promotionSummary?.filter(p => $i18n.has(`${p.name}.ribbon.offerMessage`))
    .map(p => $i18n.ts(`${p.name}.ribbon.offerMessage`))
)
</script>

<style lang="scss" scoped>
.ribbon-text {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  :deep(a) {
    color: rgb(var(--v-theme-secondary));
  }
}

// vuetify bug https://github.com/vuetifyjs/vuetify/issues/10780
.fade-transition-leave-active {
    position: absolute;
    width:100%;
}
</style>
